/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, find } from "lodash";
import { Chip, Link as LinkMui, Stack, Pagination, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { useCanView } from "../../../config/hook/UserPermissions";
import dayjs from "dayjs";

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/Table";
import TableFilter from "../../../components/form/TableFilter";
import ExpandableSection from "../../../components/form/ExpandableSection";
import { countPage } from "../../../config/const"

import { getNotifications } from "../../../store/others/thunk/notifications/getAll";
import { getRoutesImport } from "../../../store/others/thunk/notifications/getAllRoutesImport";

const Notifications = () => {
  const [__] = useTranslation("notifications");
  const dispatch = useDispatch();
  const canView = useCanView();
  const [filter, setFilter] = useState({});
  
  const notifications = useSelector(state => state.others.notifications);
  const route = useSelector(state => state.others.notifications.routesImport);
  const expiration = __(`alertStatus`, { returnObjects: true });

  const getData = () => {
     dispatch(getNotifications());
  }

  const getDataRoutesImport = ({page, filters = filter}) => {
     dispatch(getRoutesImport({page, ...filters}));
  }

  useEffect(() => {
    getData()
    getDataRoutesImport({page: 1})
  }, []);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getDataRoutesImport({ page: 1, filters: updatedFilters });
  };

    const onChangePagination = (e, page) => getDataRoutesImport({ page })

  const headTableRoutes = [
    {
      key: "message",
      label: __(`table.colsRoutes.message`),
      align: "center"
    },
    {
      key: "idRoute",
      label: __(`table.colsRoutes.idRoute`),
      align: "center"
    },
    {
      key: "customerId",
      label: __(`table.colsRoutes.customerId`),
      align: "center"
    },
    {
      key: "provider",
      label: __(`table.colsRoutes.provider`),
      align: "center"
    },
    {
      key: "date",
      label: __(`table.colsRoutes.date`),
      align: "center"
    },
  ]

   const headTableDrivers = [
     {
       key: "expiration",
       label: __(`table.colsDrivers.expiration`),
       align: "center"
     },
    {
      key: "idProvider",
      label: __(`table.colsDrivers.idProvider`),
      align: "center"
    },
    {
      key: "provider",
      label: __(`table.colsDrivers.provider`),
      align: "center"
    },
    {
      key: "idDriver",
      label: __(`table.colsDrivers.idDriver`),
      align: "center"
    },
    {
      key: "name",
      label: __(`table.colsDrivers.name`),
      align: "center"
    },
    {
      key: "license",
      label: __(`table.colsDrivers.license`),
      align: "center"
    },
    {
      key: "date",
      label: __(`table.colsDrivers.date`),
      align: "center"
    },
  ]

  const headTableTransports = [
    {
      key: "expiration",
      label: __(`table.colsTransports.expiration`),
      align: "center"
    },
    {
      key: "header",
      label: __(`table.colsTransports.header`),
      align: "center"
    },
    {
      key: "idProvider",
      label: __(`table.colsTransports.idProvider`),
      align: "center"
    },
    {
      key: "provider",
      label: __(`table.colsTransports.provider`),
      align: "center"
    },
    {
      key: "idTransport",
      label: __(`table.colsTransports.idTransport`),
      align: "center"
    },
    {
      key: "numberPlate",
      label: __(`table.colsTransports.numberPlate`),
      align: "center"
    },{
      key: "date",
      label: __(`table.colsTransports.date`),
      align: "center"
    },
  ]

  const headTableRoutesLastMile = [
    {
      key: "customerId",
      label: __(`table.colsRoutes.customerId`),
      align: "center"
    },
    {
      key: "startDP",
      label: __(`table.colsRoutes.startDP`),
      align: "center"
    },
    {
      key: "endDP",
      label: __(`table.colsRoutes.endDP`),
      align: "center"
    },
    {
      key: "division",
      label: __(`table.colsRoutes.division`),
      align: "center"
    },
    {
      key: "dateToRoute",
      label: __(`table.colsRoutes.dateToRoute`),
      align: "center"
    },
    {
      key: "transportType",
      label: __(`table.colsRoutes.transportType`),
      align: "center"
    },
    {
      key: "idRouteLastMile",
      label: __(`table.colsRoutes.idRouteLastMile`),
      align: "center"
    },
    {
      key: "status",
      label: __(`table.colsRoutes.status`),
      align: "center"
    },
    {
      key: "comments",
      label: __(`table.colsRoutes.comments`),
      align: "center"
    },
    {
      key: "creationDate",
      label: __(`table.colsRoutes.creationDate`),
      align: "center"
    },
  ]

  const dataTableRoutes = map(get(notifications, "data.routes", []), (row, i) => ({
    ...row,
    idRoute: <LinkMui component={Link} to={`/transactions/routes/${toString(get(row, "idRoute"))}`} >{get(row, "idRoute")}</LinkMui>,
    date: get(row, "date", null) && moment(get(row, "date")).locale("es").format("DD/MM/YYYY"),
  }))

   const dataTableDrivers = map(get(notifications, "data.drivers", []), (row, i) => ({
    ...row,
    idProvider: <LinkMui component={Link} to={`/masters/providers/${toString(get(row, "idProvider"))}`} >{get(row, "idProvider")}</LinkMui>,
    date: get(row, "date", null) && moment(get(row, "date")).locale("es").format("DD/MM/YYYY"),
    expiration: <Chip label={get(find(expiration, ({ value }) => value === get(row, "expiration", 1)), "label")} sx={{ bgcolor: `${get(find(expiration, ({ value }) => value === get(row, "expiration", 1)), "color")}26`, color: get(find(expiration, ({ value }) => value === get(row, "expiration", 1)), "color") }} />,
  }))

   const dataTableTransports = map(get(notifications, "data.transports", []), (row, i) => ({
    ...row,
    idProvider: <LinkMui component={Link} to={`/masters/providers/${toString(get(row, "idProvider"))}`} >{get(row, "idProvider")}</LinkMui>,
    // idTransport: <LinkMui component={Link} to={`/masters/providers/${toString(get(row, "idProvider"))}/transport/${toString(get(row, "idTransport"))}`} >{get(row, "idProvider")}</LinkMui>,
    date: get(row, "date", null) && moment(get(row, "date")).locale("es").format("DD/MM/YYYY"),
    expiration: <Chip label={get(find(expiration, ({ value }) => value === get(row, "expiration", 1)), "label")} sx={{ bgcolor: `${get(find(expiration, ({ value }) => value === get(row, "expiration", 1)), "color")}26`, color: get(find(expiration, ({ value }) => value === get(row, "expiration", 1)), "color") }} />,
  }))

  const dataTableRoutesLastMile = map(get(route, "data.data", []), (row, i) => ({
    ...row,

     status: (
      <Chip
        label={get(row, "status", "")}
        color={get(row, "status", "") === "ERROR" ? "error" : "success"}
        variant="outlined"
        size="small"
      />
    ), 

    dateToRoute:get(row, "dateToRoute", null) && moment(get(row, "dateToRoute")).locale("es").format("DD/MM/YYYY"),

    creationDate: get(row, "creationDate")
    ? dayjs(get(row, "creationDate")).format("DD/MM/YYYY HH:mm")
    : "",

  }))


  return (
    <Layout propsToolbar={{ title: __(`head.name`), code: null,  btnLabel: null }} >
      {canView("NOTIFICACIONES/RUTAS", "watch") && (
        <ExpandableSection title={__(`labels.1`)}>
         <Table headTable={headTableRoutes}
           dataTable={dataTableRoutes}
           __={__}
           sizeFilters={125}
           loading={get(notifications, "isLoading", false)}
         />
       </ExpandableSection>
      )}
      {canView("NOTIFICACIONES/CONDUCTORES", "watch") && (
       <ExpandableSection title={__(`labels.2`)}>
        <Table headTable={headTableDrivers}
          dataTable={dataTableDrivers}
          __={__}
          sizeFilters={125}
          loading={get(notifications, "isLoading", false)}
        />
       </ExpandableSection>
      )}
      {canView("NOTIFICACIONES/CAMIONES", "watch") && (
       <ExpandableSection title={__(`labels.3`)}>
        <Table headTable={headTableTransports}
          dataTable={dataTableTransports}
          __={__}
          sizeFilters={125}
          loading={get(notifications, "isLoading", false)}
        />
       </ExpandableSection>
      )}
      {canView("NOTIFICACIONES/RUTAS LASTMILE", "watch") && (
        <>
          <Typography variant="h6" sx={{ mt: 1, mb: 3, ml: 4, fontWeight: 600 }}>
            Importaciones desde LastMile:
          </Typography>
          <TableFilter headTable={headTableRoutesLastMile}
            dataTable={dataTableRoutesLastMile}
            __={__}
            sizeFilters={125}
            propsTable={{ showFilterRow: true }}
            filters={filter}
            onFilterChange={onFilterChange}
            loading={get(route, "isLoading", false)}
          />
          <Stack sx={{ mt: 2 }} alignItems="flex-end">
            <Pagination
              count={countPage(get(route, "data.totalRecord", 1))}
              page={get(route, "data.currentPage", 1)}
              onChange={onChangePagination}
              color="secondary"
              sx={{ "& li > button": { borderRadius: 1 } }}
              disabled={get(route, "isLoading", false)}
            />
          </Stack>
        </>
      )}
    </Layout>
  )
}

export default Notifications;


